var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadAllFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 7.72373C6.25 7.81591 6.13586 7.859 6.07494 7.78981L4.06293 5.50441C3.78922 5.19351 3.31531 5.16336 3.00441 5.43707C2.69351 5.71078 2.66336 6.18469 2.93707 6.49559L6.45858 10.4956C6.60149 10.6579 6.80752 10.7507 7.0238 10.75C7.24007 10.7493 7.44553 10.6553 7.58745 10.4922L11.0659 6.49215C11.3377 6.17959 11.3047 5.70587 10.9922 5.43406C10.6796 5.16225 10.2059 5.19529 9.93406 5.50785L7.92546 7.81759C7.86477 7.88738 7.75 7.84446 7.75 7.75197V1C7.75 0.585787 7.41421 0.25 7 0.25C6.58579 0.25 6.25 0.585787 6.25 1V7.72373ZM1 8.25C1.41421 8.25 1.75 8.58579 1.75 9V11C1.75 11.6904 2.30964 12.25 3 12.25H11C11.6904 12.25 12.25 11.6904 12.25 11V9C12.25 8.58579 12.5858 8.25 13 8.25C13.4142 8.25 13.75 8.58579 13.75 9V11C13.75 12.5188 12.5188 13.75 11 13.75H3C1.48122 13.75 0.25 12.5188 0.25 11V9C0.25 8.58579 0.585786 8.25 1 8.25Z",
    fill: "#BE5400"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadAllFolder);
export default __webpack_public_path__ + "static/media/download-all-folder.490046afad1e600e16a1a51704ddac44.svg";
export { ForwardRef as ReactComponent };